//
//
//
//
//

    /// 社群-
    /// 国内-zh
    /// 海外-en
    /// 日本-ja
    export default {
      name: 'index',
      data () {
        return {
          type: null
        }
      },
      mounted () {
        this.type = this.$route.params.type
        this.toURL(this.type)
      },
      methods: {
        toURL (type) {
          switch (type) {
            case 'zh':
              window.location.href = 'https://www.xiaohongshu.com/user/profile/63e36b9e0000000027028c7a'
              break
            case 'en':
              window.location.href = 'https://www.instagram.com/cocinarecoffee/'
              break
            case 'ja':
              window.location.href = 'https://www.instagram.com/epeios_jp'
              break
            default:
          }
        }
      }
    }



// WEBPACK FOOTER //
// ./src/components/community/index.vue